import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { DateUtils, FileDoc, FileType, PersonDoc } from 'common';
import { PeopleService } from 'src/global/service/PeopleService';
import { FileService } from '../../global/service/FileService';

@Component({
  tag: 'file-thumb',
  styleUrl: 'file-thumb.css',
  shadow: true,
})
export class FileThumb {
  /****************** UNUSED COMPONENT ******************/
  @Prop() file: FileDoc;
  @Prop() person: PersonDoc;
  @Prop() removable: boolean = false;
  @Prop() background: 'default' | 'step-750' | 'transparent' = 'default';
  @Prop() clickable: boolean = false;

  @Event() remove: EventEmitter;
  @Event() fileClick: EventEmitter;

  private backgroundColorsClass: { [key in 'default' | 'step-750' | 'transparent']: string } = {
    'default': 'file-thumb-default',
    'step-750': 'file-thumb-step-750',
    'transparent': 'file-thumb-transparent',
  };

  private getFileIcon(): string {
    switch (this.file.type) {
      case FileType.DRAWING:
        return '/assets/icon/drawings-icon.svg';
      case FileType.DOCUMENT:
        return '/assets/icon/contract-icon.svg';
      case FileType.PHOTO:
        return '/assets/icon/photo-album-icon.svg';
      case FileType.SPECIFICATION:
        return '/assets/icon/specifications-icon.svg';
      case FileType.SET:
        return '/assets/icon/drawing-set-icon.svg';
      case FileType.ALBUM:
        return '/assets/icon/photo-album-icon.svg';
      case FileType.FOLDER:
        return '/assets/icon/scrapbook-icon.svg';
      default:
        return '/assets/icon/contract-icon.svg';
    }
  }

  private getFileExtension(): string {
    const name = this.file.name || '';
    const lastDot = name.lastIndexOf('.');
    return lastDot > 0 ? name.substring(lastDot + 1).toUpperCase() : '';
  }

  onRemoveClick(e: Event) {
    e.stopPropagation();
    this.remove.emit(this.file);
  }

  onFileClick(e: Event) {
    if (this.clickable) {
      e.stopPropagation();
      this.fileClick.emit(this.file);
    }
  }

  render() {
    if (!this.file) {
      console.log('FileThumb: file is null');
      return null;
    }

    const fileImage = this.file.thumb ? `data:image/png;base64,${this.file.thumb}` : this.getFileIcon();
    const fileSize = FileService.getFileSize(this.file.num_bytes);
    const fileExtension = this.getFileExtension();
    const hasThumbnail = this.file.thumb && this.file.thumb.trim() !== '';

    return (
      <div class={`file-thumb ${this.backgroundColorsClass[this.background]} ${this.clickable ? 'clickable' : ''}`} onClick={e => this.onFileClick(e)}>
        <div class="file-image">{hasThumbnail ? <img src={fileImage} alt={this.file.name} /> : <img src={fileImage} alt={this.file.name} class="file-icon" />}</div>
        <div class="file-info">
          <ion-label class="file-name">{this.file.name}</ion-label>
          <small class="file-details">
            {fileExtension} {fileSize && `• ${fileSize}`}
            {this.file.num_pages && ` • ${this.file.num_pages} pages`}
          </small>
          <small class="file-date">
            {PeopleService.getFullName(this.person)} • {DateUtils.formatIso(this.file.created_date)}
          </small>
        </div>
        {this.removable && <ion-icon name="close-circle" onClick={e => this.onRemoveClick(e)}></ion-icon>}
      </div>
    );
  }
}
